const alljournalentry = { data: [], loading: true, cache: {} };

export const GetAllJournalEntry = (state = alljournalentry, action) => {
  switch (action.type) {
    case "get_alljournalentry":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };
    case "clear_journalentry_cache":
      return {
        ...state,
        cache: {},
      };
    default:
      return state;
  }
};
